import React, {useEffect} from 'react';
import {Card} from '@mui/material';
import {TextField} from 'formik-mui';
import {Field, useFormikContext} from 'formik';

export default function AcquisitionEntryThree({code}) {
  const {values, setFieldValue} = useFormikContext();

  useEffect(() => {
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month < 10 ? `0${month}` : month;
      let day = date.getDate();
      day = day < 10 ? `0${day}` : day;
      return `${year}-${month}-${day}`;
    };

    if (values?.date_of_entry) {
      const formattedCompletionDate = formatDate(values.date_of_entry);
      setFieldValue('date_of_entry', formattedCompletionDate);
    }
  }, [values.date_of_entry, setFieldValue]);

  return (
    <div>
      <Card className={'box-shadow'} sx={{p: 4}}>
        <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Price'}
               name={`price`}
               sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
        <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Appraised Value'}
               name={`appraised_value`} sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
        <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Storage'}
               name={`translations.${code}.storage`}
               sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
        <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Location'}
               name={`translations.${code}.location`}
               sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
        <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Date of Entry'}
               name={`date_of_entry`} type={'date'}
               sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
        {/*<Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Remarks'}*/}
        {/*       name={`remarks`} multiline rows={3}*/}
        {/*       sx={{mt: 1.5}}*/}
        {/*       InputLabelProps={{*/}
        {/*         style: {fontSize: 14, color: '#929191'},*/}
        {/*         shrink: true*/}
        {/*       }}/>*/}
      </Card>
    </div>
  );
}